export default __webpack_public_path__ + "static/details-9f00b65108a0cb6faea3f647f0dfab48.png";